import { useEffect } from "react";
import ReactDOM from "react-dom";

// Only S, M, L, XL data
const sizeGuideDataCm = {
  headers: ["S", "M", "L", "XL", "2XL"],
  rows: [
    {
      label: "Length",
      values: [69, 73, 75, 77, 79],
    },
    {
      label: "Width",
      values: [49.5, 53.5, 56.5, 59.5, 63.5],
    },
    {
      label: "Sleeve length",
      values: [22.5, 24, 24.5, 25, 25.5],
    },
  ],
};

const sizeGuideDataInches = {
  headers: ["S", "M", "L", "XL", "2XL"],
  rows: [
    {
      label: "Length",
      values: ["27 ⅛", "28 ¾", "29 ½", "30 ¼", "31 ⅛"],
    },
    {
      label: "Width",
      values: ["19 ½", "21", "22 ¼", "23 ⅜", "25"],
    },
    {
      label: "Sleeve length",
      values: ["8 ⅞", "9 ½", "9 ⅝", "9 ⅞", "10"],
    },
  ],
};

const sizeGuideDataCmJumper = {
  headers: ["S", "M", "L", "XL", "2XL", "3XL"],
  rows: [
    {
      label: "Length",
      values: [69, 71, 74, 76, 79, 81],
    },
    {
      label: "Width",
      values: [51, 53, 58, 64, 67, 71],
    },
  ],
};

const sizeGuideDataInchesJumper = {
  headers: ["S", "M", "L", "XL", "2XL", "3XL"],
  rows: [
    {
      label: "Length",
      values: [27, 28, 29, 30, 31, 32],
    },
    {
      label: "Width",
      values: [20, 21, 23, 25, 27, 28],
    },
  ],
};

const sizeGuideDataCmHat = {
  headers: ["One size"],
  rows: [
    { label: "Circumference", values: ["52 - 62"] },
    { label: "Height", values: [12] },
    { label: "Width", values: [19] },
  ],
};

const sizeGuideDataInchesHat = {
  headers: ["One size"],
  rows: [
    { label: "Circumference", values: ["20 ½ - 24 ⅜"] },
    { label: "Height", values: ["4 ¾"] },
    { label: "Width", values: ["7 ½"] },
  ],
};

const SizeGuidePopup = ({ open, onClose, category }) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  // Choose data based on category
  const cat = category ? category.toLowerCase() : "";
  const isJumper = cat === "jumpers";
  const isHat = cat === "hats" || cat === "hat";
  const cmData = isHat
    ? sizeGuideDataCmHat
    : isJumper
      ? sizeGuideDataCmJumper
      : sizeGuideDataCm;
  const inchesData = isHat
    ? sizeGuideDataInchesHat
    : isJumper
      ? sizeGuideDataInchesJumper
      : sizeGuideDataInches;

  if (!open) return null;
  return ReactDOM.createPortal(
    <div className="size-guide-popup-overlay" onClick={onClose}>
      <div className="size-guide-content" onClick={(e) => e.stopPropagation()}>
        <h3>Size Guide</h3>
        <h2>Centimeters</h2>
        <table className="size-guide-table">
          <thead>
            <tr>
              <th></th>
              {cmData.headers.map((header) => (
                <th key={header}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {cmData.rows.map((row) => (
              <tr key={row.label}>
                <td>{row.label}</td>
                {row.values.map((value, idx) => (
                  <td key={idx}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <h2>Inches</h2>
        <table className="size-guide-table">
          <thead>
            <tr>
              <th></th>
              {inchesData.headers.map((header) => (
                <th key={header}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {inchesData.rows.map((row) => (
              <tr key={row.label}>
                <td>{row.label}</td>
                {row.values.map((value, idx) => (
                  <td key={idx}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <button onClick={onClose} className="si_button">
          Close
        </button>
      </div>
    </div>,
    document.body,
  );
};

const SizeGuide = ({ category }) => {
  // Choose data based on category
  const cat = category ? category.toLowerCase() : "";
  const isJumper = cat === "jumpers";
  const isHat = cat === "hats" || cat === "hat";
  const cmData = isHat
    ? sizeGuideDataCmHat
    : isJumper
      ? sizeGuideDataCmJumper
      : sizeGuideDataCm;
  const inchesData = isHat
    ? sizeGuideDataInchesHat
    : isJumper
      ? sizeGuideDataInchesJumper
      : sizeGuideDataInches;

  return (
    <div className="size-guide-content_two">
      <h2>Centimeters</h2>
      <table className="size-guide-table">
        <thead>
          <tr>
            <th></th>
            {cmData.headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {cmData.rows.map((row) => (
            <tr key={row.label}>
              <td>{row.label}</td>
              {row.values.map((value, idx) => (
                <td key={idx}>{value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <h2>Inches</h2>
      <table className="size-guide-table">
        <thead>
          <tr>
            <th></th>
            {inchesData.headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {inchesData.rows.map((row) => (
            <tr key={row.label}>
              <td>{row.label}</td>
              {row.values.map((value, idx) => (
                <td key={idx}>{value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SizeGuidePopup;
export { SizeGuide };
